// extracted by mini-css-extract-plugin
module.exports = {"paginatedHits":"PaginatedHits_paginatedHits__FXa42","productListContainer":"PaginatedHits_productListContainer__Pb7lA"};